import script from "./SpacesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SpacesView.vue?vue&type=script&setup=true&lang=js"

import "./SpacesView.vue?vue&type=style&index=0&id=33f3576c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f3576c"]])

export default __exports__